import React from "react";
import Grid from "@mui/material/Grid";
import { withTranslation } from "react-i18next";
import i18n from "../../i18n";

const { VITE_REDIRECT_TO_OLD_URL } = import.meta.env;
const copyright = (props) => (
  <>
    <Grid item xs={12} sm={6} className="copyright">
      <span id="Footer-LNK-Copy-Rights">{i18n.t("footer.copyRight")} | </span>
      <a
        href="#"
        id="Footer-LNK-CookiePolicy"
        onClick={() =>
          props.showHelp(
            `${VITE_REDIRECT_TO_OLD_URL}/help/terms_and_conditions_index.html?cookie_policy.html`
          )
        }
        rel="noopener noreferrer"
      >
        {i18n.t("footer.cookiePolicy")}
      </a>
    </Grid>
  </>
);

export default withTranslation()(copyright);
